import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSubscription } from "./SubscriptionContext";

/**
 * Keeps subscription limits in sync after billing flows without per-page refetches.
 * Refetches when the user leaves /plans routes (checkout, upgrade, downgrade).
 */
export function SubscriptionSync() {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const { refetchSubscription } = useSubscription();

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const wasPlansRoute = prevPath.startsWith("/plans");
    const isPlansRoute = location.pathname.startsWith("/plans");

    if (wasPlansRoute && !isPlansRoute) {
      void refetchSubscription?.();
    }

    prevPathRef.current = location.pathname;
  }, [location.pathname, refetchSubscription]);

  return null;
}
